export default (fetch: typeof $fetch) => ({
  get: async <T extends Record<string, any>>(fields: (keyof T)[]): Promise<T> => {
    const fieldNames = fields.map((name) => encodeURIComponent(String(name))).join(',');
    const response = await fetch<T>(`rys/v1/options?field_names=${fieldNames}`);
    return response;
  }
});
